import {Injectable, Injector} from '@angular/core';
import {BaseApiService} from '@carm/_core/baseapi.service';
import {Observable} from 'rxjs';

import {environment} from '../../../environments/environment';
import {IBaseResponse} from '@carm/_utils/models';
import {IAnalytics} from '@carm/_core/analytics/analytics.model';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService extends BaseApiService {


  constructor(protected injector: Injector) {
    super(injector);
  }


  analytics(event) {
    let url = event.url

    const regex = /\/private\/nb\/(\d+)\/p\/(\w+)/;
    const match = url.match(regex);

    let browser;
    let businessId;
    let page;
    let deviceType;
    let isThirdParty;
    let operatingSystem;
    let programId;


    if (match) {
      const business = match[1]; // Extract the number after 'nb'
      const program = match[2]; // Extract the string after 'p'
      let thirdParty = false;


      if (!program.includes(business)) {
        thirdParty = true;
      }

      businessId = business;
      programId = program;
      isThirdParty = thirdParty;

      page = url.split("/p/" + program)[1];
    } else {

      if (url.includes('/private/')) {
        page = url.split("/private/")[1];
      } else if (url.includes('/public/')) {
        page = url.split("/public/")[1];
      } else {
        page = url;
      }

    }

    page = page.split('?')[0].split("#")[0];
    browser = this.browser();
    deviceType = this.deviceType();
    operatingSystem = this.operatingSystem();


    return {browser, businessId, deviceType, isThirdParty, operatingSystem, page, programId};
  }

  operatingSystem() {
    const userAgent = navigator.userAgent;

    let operatingSystem;

    if (/Windows/.test(userAgent)) {
      operatingSystem = "Windows";
    } else if (/Macintosh/.test(userAgent)) {
      operatingSystem = "Macintosh";
    } else if (/Android/.test(userAgent)) {
      operatingSystem = "Android";
    } else if (/iPadOS/.test(userAgent)) {
      operatingSystem = "iPadOS";
    } else if (/iOS/.test(userAgent)) {
      operatingSystem = "iOS";
    } else if (/Linux/.test(userAgent)) {
      operatingSystem = "Linux";
    } else {
      operatingSystem = "Unknown";
    }

    return operatingSystem;
  }

  browser() {
    const userAgent = navigator.userAgent;

    let browser;

    if (/Firefox\//.test(userAgent)) {
      browser = "Firefox";
    } else if (/OPR\//.test(userAgent) || /Opera\//.test(userAgent)) {
      browser = "Opera";
    } else if (/Edg\//.test(userAgent)) {
      browser = "Microsoft Edge";
    } else if (/Chrome\//.test(userAgent)) {
      browser = "Google Chrome";
    } else if (/Safari\//.test(userAgent)) {
      browser = "Safari";
    } else if (/MSIE\//.test(userAgent) || /Trident\//.test(userAgent)) {
      browser = "Internet Explorer";
    } else {
      browser = "Unknown";
    }

    return browser;
  }

  deviceType() {
    const userAgent = navigator.userAgent;

    let deviceType;

    if (/iPad|Android|tablet/i.test(userAgent)) {
      deviceType = "Tablet";
    } else if (/iPhone|Android|mobile/i.test(userAgent)) {
      deviceType = "Mobile";
    } else {
      deviceType = "Desktop";
    }

    return deviceType;
  }


  public sendAnalytics(eventData): Observable<IBaseResponse> {
    const baseUrl = this.getBaseUrl();

    const endPoint = `${baseUrl}analytics`;

    const body: IAnalytics = {
      browser: eventData.browser,
      business: eventData.businessId,
      deviceType: eventData.deviceType,
      isThirdParty: eventData.isThirdParty,
      operatingSystem: eventData.operatingSystem,
      page: eventData.page,
      program: eventData.programId
    };

    return this.httpAuthPost<IBaseResponse>(endPoint, body);
  }

  private getBaseUrl(): string {
    return `${environment.baseApiUrls}/`;
  }
}
